import React, { useEffect, useState } from 'react';
import LancamentoViewSimple from '../LancamentoViewSimple';
import {
    useParams
} from "react-router-dom";
import { findLancamentoByCodigo } from '../api-lancamento';
import { errorMessage } from '../../../util/ConfirmAlertUtil';
import { Grid } from '@mui/material';
import LancamentoPagamentoPorCreditoForm from './LancamentoPagamentoPorCreditoForm';

const LancamentoPagamentoPorCreditoContainer = () => {
    const { codLancamento } = useParams();
    const [lancamento, setLancamento] = useState(null);


    useEffect(() => {
        if (codLancamento) {
            findLancamentoByCodigo(codLancamento).then((data) => {
                if (data) {
                    if (data.error) {
                        errorMessage(data.message);
                    } else {
                        setLancamento(data);
                    }
                }
            })
        }
    }, [codLancamento]);

    return (
        <Grid container spacing={2} justifyContent='center'>
            <Grid size={12}>
                <LancamentoViewSimple lancamento={lancamento} />

            </Grid>
            <Grid style={{ marginTop: '20px' }} size={12}>
                <LancamentoPagamentoPorCreditoForm lancamento={lancamento} />
            </Grid>
        </Grid>
    );
}

export default LancamentoPagamentoPorCreditoContainer;